var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonetiseVen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_5166_5045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3507 5.83518C18.9325 3.61586 16.7405 2.08518 14.17 1.52609C14.0848 1.50564 13.9961 1.52268 13.9211 1.57041C13.8461 1.62154 13.795 1.69314 13.7746 1.77836L11.7359 11.0681C11.7086 11.184 11.7496 11.3068 11.8348 11.3852L18.8575 17.7977C18.9189 17.8556 19.0007 17.8829 19.0791 17.8829C19.1677 17.8829 19.2564 17.8454 19.3246 17.7772C20.4871 16.5159 21.3018 14.9477 21.6734 13.25C22.2393 10.6829 21.7689 8.05109 20.3507 5.83518ZM14.2893 8.52495L15.445 7.43745C15.4961 7.38973 15.5575 7.36245 15.6223 7.35223L16.7405 7.18859L17.5041 6.40109L17.3677 6.40791C17.1905 6.42154 17.0302 6.27836 17.02 6.09427C17.0132 5.91359 17.153 5.75677 17.3337 5.74654L18.3121 5.69541C18.3393 5.69541 18.3666 5.69541 18.3905 5.70223C18.4211 5.70904 18.4518 5.71927 18.4791 5.73632H18.4825C18.5132 5.75336 18.5371 5.77041 18.5575 5.79086C18.6052 5.83859 18.6325 5.89654 18.6461 5.95791C18.653 5.98518 18.6564 6.00904 18.6564 6.03291L18.6325 7.00791C18.6291 7.18859 18.4791 7.33177 18.3018 7.33177C18.2984 7.33177 18.2984 7.33177 18.295 7.33177C18.1143 7.32836 17.9677 7.17495 17.9711 6.99427L17.9746 6.8545L17.1325 7.72382C17.0814 7.77495 17.0166 7.80904 16.945 7.81927L15.8166 7.98291L14.7359 8.99882C14.6746 9.05677 14.5893 9.08745 14.5075 9.08745C14.4223 9.08745 14.3336 9.05336 14.2689 8.98518C14.1496 8.86245 14.1564 8.65109 14.2893 8.52495ZM19.57 11.4772H13.8291C13.645 11.4772 13.4984 11.3272 13.4984 11.1465C13.4984 10.9659 13.645 10.8159 13.8291 10.8159H14.1325V10.1443C14.1325 9.96359 14.2825 9.81359 14.4632 9.81359C14.6439 9.81359 14.7939 9.96359 14.7939 10.1443V10.8159H15.5711V9.43518C15.5711 9.2545 15.7211 9.1045 15.9018 9.1045C16.0825 9.1045 16.2325 9.2545 16.2325 9.43518V10.8159H17.0098V8.617C17.0098 8.43632 17.1564 8.28632 17.3405 8.28632C17.5211 8.28632 17.6711 8.43632 17.6711 8.617V10.8159H18.4484V8.01359C18.4484 7.83291 18.595 7.68291 18.7791 7.68291C18.9598 7.68291 19.1098 7.83291 19.1098 8.01359V10.8159H19.57C19.7507 10.8159 19.9007 10.9659 19.9007 11.1465C19.9007 11.3272 19.7507 11.4772 19.57 11.4772Z",
    fill: "url(#paint0_linear_5166_5045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4775 11.6875L9.90135 12.0591L2.39112 16.8625L1.83203 17.2239C3.25021 19.2898 5.36726 20.7182 7.82862 21.2568C8.52748 21.4102 9.22635 21.4852 9.92862 21.4852C12.6661 21.4852 15.3252 20.3432 17.207 18.2807C17.3298 18.1443 17.3195 17.9364 17.1832 17.8136L10.4775 11.6875Z",
    fill: "url(#paint1_linear_5166_5045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64563 11.4367L10.4297 10.939L12.3013 2.41969C12.3218 2.33446 12.3047 2.24582 12.2536 2.17082C12.2059 2.09923 12.1343 2.04469 12.049 2.02423C6.74449 0.86514 1.48426 4.23332 0.321762 9.53446C-0.216874 11.9924 0.192217 14.5151 1.47063 16.6697L2.02972 16.3117L9.64563 11.4367Z",
    fill: "url(#paint2_linear_5166_5045)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5166_5045",
    x1: 16.8173,
    y1: 1.51758,
    x2: 16.8173,
    y2: 17.8829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5166_5045",
    x1: 9.56235,
    y1: 11.6875,
    x2: 9.56235,
    y2: 21.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5166_5045",
    x1: 6.20004,
    y1: 1.7959,
    x2: 6.20004,
    y2: 16.6697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#716DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04006D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5166_5045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8182,
    height: 21.8182,
    fill: "white",
    transform: "translate(0.0908203 0.59082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetiseVen);
export default __webpack_public_path__ + "static/media/monetise-ven.fb2c325e0584b6e02681c240c3c1d178.svg";
export { ForwardRef as ReactComponent };